'use es6';

import GoodFiltersAndPage from '../constants/GoodFiltersAndPage';
import TemplatePurposeOptions from '../constants/TemplatePurposeOptions';
import TemplatePurposeOptionsArray from '../constants/TemplatePurposeOptionsArray';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';
import React from 'react';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UISelect from 'UIComponents/input/UISelect';
import { getAlphaSortedArrOfTextValPairsForSelect } from '../utils/utils';
import { getTemplatePurposeOptionText } from '../utils/langUtils';
export default createReactClass({
  displayName: "TemplatePurposeDropdown",
  mixins: [PureRenderMixin],
  propTypes: {
    onGoodFilterChange: PropTypes.func.isRequired,
    templatePurposeFilter: PropTypes.string.isRequired
  },
  handlePurposeUpdate: function handlePurposeUpdate(event) {
    var params = {};
    params[GoodFiltersAndPage.TEMPLATE_PURPOSE] = event.target.value;
    return this.props.onGoodFilterChange(params);
  },
  render: function render() {
    var templatePurposeFilter = this.props.templatePurposeFilter;
    return React.createElement(UIFormControl, {
      label: getTemplatePurposeOptionText('title')
    }, React.createElement(UISelect, {
      buttonUse: "transparent",
      className: "integrate-intent-dropdown p-x-0 p-top-0",
      menuWidth: 250,
      onChange: this.handlePurposeUpdate,
      options: getAlphaSortedArrOfTextValPairsForSelect(TemplatePurposeOptionsArray, getTemplatePurposeOptionText, TemplatePurposeOptions.ALL),
      placeholder: getTemplatePurposeOptionText(templatePurposeFilter),
      placement: "bottom right",
      value: templatePurposeFilter
    }));
  }
});